import type { DossierHistoryStep } from '../types/dossierHistory.types';

const DOSSIER_HISTORY_BY_FILE_ID: Record<string, DossierHistoryStep[]> = {
  'a1000001-0000-4000-8000-000000000001': [
    {
      id: 'hist-001-1',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Dossier créé',
      date: '2024-01-15',
      actorLabel: 'Marie Dupont',
    },
    {
      id: 'hist-001-2',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Document ajouté',
      date: '2024-01-16',
      actorLabel: 'Marie Dupont',
    },
    {
      id: 'hist-001-3',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Document ajouté',
      date: '2024-01-16',
      actorLabel: 'Marie Dupont',
    },
    {
      id: 'hist-001-4',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Statut mis à jour',
      date: '2024-01-17',
      actorLabel: 'Martin Dupont',
    },
    {
      id: 'hist-001-5',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Étiquette générée',
      date: '2024-01-18',
      actorLabel: 'Système',
    },
    {
      id: 'hist-001-6',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Statut mis à jour',
      date: '2024-02-10',
      actorLabel: 'Système',
    },
    {
      id: 'hist-001-7',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      label: 'Dossier clôturé',
      date: '2024-02-20',
      actorLabel: 'Martin Dupont',
    },
  ],
  'a1000002-0000-4000-8000-000000000002': [
    {
      id: 'hist-002-1',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      label: 'Dossier créé',
      date: '2024-01-18',
      actorLabel: 'Thomas Bernard',
    },
    {
      id: 'hist-002-2',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      label: 'Document ajouté',
      date: '2024-01-19',
      actorLabel: 'Thomas Bernard',
    },
    {
      id: 'hist-002-3',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      label: 'Statut mis à jour',
      date: '2024-01-22',
      actorLabel: 'Sophie Bernard',
    },
    {
      id: 'hist-002-4',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      label: 'Relance envoyée',
      date: '2024-02-10',
      actorLabel: 'Système',
    },
    {
      id: 'hist-002-5',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      label: 'Statut mis à jour',
      date: '2024-02-22',
      actorLabel: 'Système',
    },
  ],
  'a1000003-0000-4000-8000-000000000003': [
    {
      id: 'hist-003-1',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      label: 'Dossier créé',
      date: '2024-02-01',
      actorLabel: 'Sophie Martin',
    },
    {
      id: 'hist-003-2',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      label: 'Document ajouté',
      date: '2024-02-02',
      actorLabel: 'Sophie Martin',
    },
    {
      id: 'hist-003-3',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      label: 'Statut mis à jour',
      date: '2024-02-08',
      actorLabel: 'Pierre Martin',
    },
    {
      id: 'hist-003-4',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      label: 'Étiquette générée',
      date: '2024-02-12',
      actorLabel: 'Système',
    },
    {
      id: 'hist-003-5',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      label: 'Statut mis à jour',
      date: '2024-02-25',
      actorLabel: 'Système',
    },
  ],
};

const DEFAULT_HISTORY: DossierHistoryStep[] = [
  {
    id: 'hist-default-1',
    fileId: 'default',
    label: 'Dossier créé',
    date: '2024-02-01',
    actorLabel: 'Client',
  },
  {
    id: 'hist-default-2',
    fileId: 'default',
    label: 'Document ajouté',
    date: '2024-02-02',
    actorLabel: 'Client',
  },
  {
    id: 'hist-default-3',
    fileId: 'default',
    label: 'Statut mis à jour',
    date: '2024-02-03',
    actorLabel: 'Système',
  },
];

export const getDossierHistoryByFileId = (fileId: string): DossierHistoryStep[] =>
  DOSSIER_HISTORY_BY_FILE_ID[fileId] ??
  DEFAULT_HISTORY.map((step) => ({ ...step, fileId }));
